import { DOCUMENT, isPlatformBrowser, registerLocaleData } from '@angular/common';
import { DestroyRef, inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import localeDE from '@angular/common/locales/de';
import localeFR from '@angular/common/locales/fr';
import localeNL from '@angular/common/locales/nl';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/nl';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
registerLocaleData(localeDE, 'de-DE');
registerLocaleData(localeFR, 'fr-FR');
registerLocaleData(localeNL, 'nl-NL');
@Injectable(
    { providedIn: 'root' }
)
export class I18nService {
    data: {};
    private _currentLang: string;
    private _locales = {
        de: localeDE,
        fr: localeFR,
        nl: localeNL
    };

    private lang$: BehaviorSubject<string>;
    destroyRef = inject(DestroyRef);

    constructor(
        @Inject(DOCUMENT) protected dom,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.lang$ = new BehaviorSubject('de');
    }

    public get lang(): string {
        return this._currentLang || 'de';
    }

    public get langLong(): string {
        if (this._currentLang) {
            return this._currentLang + '-' + this._currentLang?.toLocaleUpperCase();
        } else {
            return 'de-DE'
        }
    }

    public get langOb() {
        return this.lang$.asObservable();
    }

    public get langUp() {
        return this._currentLang?.toLocaleUpperCase() || 'DE';
    }

    setLanguage(lang): void {
        if (this._locales[lang] && this._currentLang !== lang) {
            // console.log(this._locales[lang]);
            registerLocaleData(this._locales[lang], lang + '-' + lang.toLocaleUpperCase());
            // console.log(lang + '-' + lang.toLocaleUpperCase())
            this._currentLang = lang;
        }
        this._currentLang = lang;
        moment.locale(this._currentLang);
        if (isPlatformBrowser(this.platformId)) {
            // this.fetch(lang); // not need we use deepl
            this.lang$.next(lang);
        }
    }

    public translate(key: string, lang?: string): string {
        lang = lang || this.lang;
        return this.data?.[key] || key;
    }
}
